import {
    $, addAction, doAction, INIT,
} from '@situation/setdesign.util';

addAction('showModal', ($modal) => {
    const $this = $($modal);
    if ($this.attr('id') === 'media-modal') {
        const $mediaCard = $this.find('.media-card');
        $mediaCard.addClass('media-card--in-modal');
        $mediaCard.removeAttr('style');
    }
});

addAction(INIT, () => {
    const $hideModalButton = $('.hide-modal');
    $hideModalButton.each((index, value) => {
        const $button = $(value);
        $button.click((e) => {
            e.preventDefault();
            const $modal = $button.parents('.modal');
            doAction('hideModal', $modal);
        });
    });
});
